import { ErrorHandler, Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private isBrowser: boolean;

  constructor(
    private injector: Injector,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  handleError(error: any): void {
    const message = error?.message || '';

    // Suppress known non-fatal Firebase Auth SSR errors
    if (message.includes('INTERNAL ASSERTION FAILED: Expected a class definition')) {
      return;
    }

    // Check if the error is a chunk load error
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(message) && this.isBrowser) {
      window.location.reload();
    } else {
      console.error('An error occurred:', error);
    }
  }
}
